@if(loadingData==false){
<div class="card mb-10">
  <span class="!text-black !font-bold !text-hover-primary !text-base">
    {{"ACCOUNT_SETTINGS.USER" | translate}}: {{ user.firstName }} {{ user.lastName }}
  </span>
</div>

<div class="card !p-2">
  <p-tabs [value]="tabValue">
    <p-tablist>
      <p-tab [value]="0">{{"ACCOUNT_SETTINGS.CONTACT_INFO.CONTACT_INFO" | translate}}</p-tab>
      <p-tab [value]="1">{{"ACCOUNT_SETTINGS.GENERAL_INFO.GENERAL_INFO" | translate}}</p-tab>
      <p-tab [value]="2">{{"ACCOUNT_SETTINGS.EDIT_USER.EDIT_USER" | translate}}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <!-- Contact Info -->
        <contact-info [user]="user" />
      </p-tabpanel>
      <p-tabpanel [value]="1">
        <!-- General Info -->
        <general-info [user]="user" />
      </p-tabpanel>
      <p-tabpanel [value]="2">
        <!-- Edit User Info -->
        <edit-user [user]="user" />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
}@else {
<chl-loader />
}
